import script from "./IndexInvoiceFive.vue?vue&type=script&lang=ts&setup=true"
export * from "./IndexInvoiceFive.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__